module.exports = __webpack_public_path__ + "img/Antonia&Stephan-08.4f1d59f4.jpg";